<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> View Question Bank </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col sm="3" v-if="crs_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="crs" item-value="crs_id" :items="crs_list"
            item-text="crs_name" label="Subject" outlined @change="getchapter()" @click="putnull" />
        </v-col>
        <v-col sm="3" v-if="chapter_list != null && crs">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="chapter" item-value="ch_id"
            :items="chapter_list" item-text="ch_name" label="Chapter" outlined @click="putnull" />
        </v-col>
        <v-col sm="3" v-if="chapter_list != null && crs">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="type" item-value="id" :items="quiz_type_list"
            item-text="display_name" label="Quiz Type" outlined @click="putnull" />
        </v-col>
        <v-col sm="3" v-if="chapter_list != null && crs">

          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="Level" item-value="Level_id"
            :items="Level_listAll" item-text="Level_name" label="Difficulty Level" outlined @click="putnull" />
        </v-col>

      </v-row>
      <v-row justify="center">
        <v-col sm="4" v-if="chapter_list != null && crs" class="text-center">
          <p></p>
          <v-btn class="button mt-9" v-if="chapter_list != null && crs" @click="viewBank()">View Question Bank</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="question_list != null">
        <span class="slide">
          Note :: You can edit or delete those questions which are added by you
          and questions that are not offered are editable and deletable.</span>
        <v-col cols="12" sm="12" md="12">
          <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Chapter</th>
                <th>Quiz Type</th>
                <th>Question</th>
                <th>Difficulty Level</th>
                <th>Question file</th>
                <th>Weightage</th>
                <th>View Question</th>
                <th>Edit</th>
                <th>Delete</th>
                <!-- <th>Is Approved</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="q in question_list" :key="q.id">
                <td>{{ q.srno }}</td>
                <td>{{ q.chapter }}</td>
                <td>{{ q.display_name }}</td>
                <td>
                  <span v-if="q.question" v-html="q.question"> </span>
                </td>
                <td>{{ q.level }}</td>
                <td>
                  <span v-if="q.filepath">
                    <a class="p-2" :href="aws_path + q.filepath + q.filename" target="blank">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-if="q.filepath != null" v-bind="attrs" v-on="on">
                            <v-icon color="black">mdi-eye</v-icon></v-btn>
                        </template>
                        <span> View Question File!!! </span>
                      </v-tooltip>
                    </a>
                  </span>
                  <span v-else> -- </span>
                </td>
                <td>
                  {{ q.weightage }}
                </td>
                <td>
                  <v-btn icon @click="viewQuizQuestion(q)">
                    <v-icon color="black">mdi-eye</v-icon></v-btn>
                </td>
                <td>
                  <span v-if="q.edit == 'YES'">
                    <!-- <v-btn
                      color="#0F2027"
                      fab
                      x-small
                      outlined
                      icon
                      @click="editItem(q.id)"
                    >
                      <v-avatar style="" class="edit-avatar">
                        <v-icon color="#0F2027" class="edit-v-icon"
                          >edit</v-icon
                        >
                      </v-avatar>
                    </v-btn> -->
                    <v-btn color="#0F2027" fab x-small outlined icon @click="edit(q)">
                      <v-avatar style="" class="edit-avatar">
                        <v-icon color="#0F2027" class="edit-v-icon">edit</v-icon>
                      </v-avatar>
                    </v-btn>
                  </span>
                  <span v-if="q.edit == 'NO'">
                    <span class="slide"> -- </span>
                  </span>
                </td>
                <td>
                  <span v-if="q.edit == 'YES'">
                    <v-btn color="error" fab x-small outlined icon @click="deleteitem(q.id)">
                      <v-avatar style="" class="delete-avatar">
                        <v-icon color="erro" class="delete-v-icon">delete</v-icon>
                      </v-avatar>
                    </v-btn>
                  </span>
                  <span v-if="q.edit == 'NO'">
                    <span class="slide"> -- </span>
                  </span>
                </td>
                <!-- <td>
                  <span v-if="q.isapproved">
                    <v-icon class="mr-2 v-icon-size" color="success"
                      >mdi-check-circle-outline</v-icon
                    >
                  </span>
                  <span v-else>
                    <v-icon class="mr-2 v-icon-size" color="error"
                      >mdi-close-circle-outline</v-icon
                    >
                  </span>
                </td> -->
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="dialog_delete_que" persistent max-width="500px">
      <v-card>
        <v-container>
          <v-card class="box">
            <input type="hidden" v-model="deleteItem.delete_id" />
            <strong>Are you sure you want Delete this Question???</strong>
            <v-row dense justify="center">
              <v-btn class="button" @click="dialog_delete_que = false">No</v-btn>
              <v-btn class="button" @click="deletequestion()">Yes</v-btn>
            </v-row>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
    <Span v-if="question_info != ''">
      <v-dialog v-model="dialog_edit" persistent fullscreen>
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong> Edit Question -{{ quiz_question }}</strong>
            </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn rounded small @click="dialog_edit = false">Close</v-btn>
          </v-toolbar>
          <v-col cols="12" sm="12" md="12">

            <v-row>
              <v-col cols="12" sm="8"> <span class="slide">*NOTE:Question or Option Image File size Should be
                  less than
                  {{ imagesize_new }} KB And It Should be in
                  <span v-for="(img, index) in imagetype_new" :key="index">
                    {{ img.imagetype }} </span>Format!!!</span></v-col>

              <v-col cols="12" sm="3">

                <v-autocomplete color="#0F2027" dense rounded required v-model="Level_name" item-value="Level_id"
                  :items="Level_list" item-text="Level_name" label="Difficulty Level" outlined />
              </v-col>
            </v-row>

            <v-card class="box">
              <!-- <v-card class="box"> -->
              <v-row justify="center">
                <span v-if="imageSizeFlag">
                  <v-col cols="12" xs="12" sm="12">
                    <p class="slide">
                      Question File size should be less than
                      {{ imagesize_new }}KB!
                    </p>
                  </v-col>
                </span>
                <span v-if="imageTypeFlag">
                  <v-col cols="12" xs="12" sm="12">
                    <p class="slide">
                      Question File in
                      <span v-for="(img, index) in imagetype_new" :key="index">
                        {{ img.imagetype }}
                      </span>
                      Format!!!
                    </p>
                  </v-col>
                </span>
              </v-row>
              <!-- ck editor show -->
              <div>
                <v-btn icon @click="showEditor" style="float: right">
                  <v-icon title="CK Text Editor" color="black">mdi-file-edit-outline</v-icon></v-btn>
                <!-- </v-col> -->
              </div>
              <!-- subjective edit -->
              <v-row dense>
                <v-col cols="12" sm="1" md="1">
                  <v-text-field color="#0F2027" label="Marks" v-model.trim="question_info[0].weightage" type="number"
                    required></v-text-field>
                </v-col>
                <v-col cols="12" sm="1" md="1">
                  <!-- <v-checkbox
                    color="#0F2027" 
                    v-model="question_info[0].isapproved"
                    class="mx-2"
                    label="Is Approve"
                  ></v-checkbox> -->
                </v-col>
                <v-col cols="12" sm="5" md="5">
                  <!-- <ckeditor
                    v-model="question_info[0].question"
                    :config="editorConfig"
                  ></ckeditor> -->

                  <v-textarea label="Editable " auto-grow v-model="question_info[0].question" outlined
                    rows="3"></v-textarea>

                  <label>Question:</label>
                  <span v-html="question_info[0].question"></span>
                </v-col>
                <v-col cols="12" sm="1" md="1"></v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-col cols="12" sm="10">
                    <v-file-input v-model="qfile" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size
                      name="doc" accept="image/*" @change="validateFile()"></v-file-input>
                    <span v-if="question_info[0].filepath != null">
                      Previous File <br />
                      <a class="p-2" :href="aws_path +
      question_info[0].filepath +
      question_info[0].filename
      " target="_blank">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-if="question_info[0].filepath !== null" v-bind="attrs" v-on="on">
                              <v-icon color="black">mdi-eye</v-icon></v-btn>
                          </template>
                          <span> View Question File!!! </span>
                        </v-tooltip>
                      </a>
                      <v-icon color="red"
                        @click="deletedialog_question(question_info[0].qid)">mdi-delete-circle</v-icon>
                    </span>
                  </v-col>
                </v-col>
              </v-row>
              <v-row dense justify="center" v-if="question_info[0].quiztype == 'SUBJECTIVE'">
                <v-col cols="12" sm="6" md="6">
                  <v-textarea label="Add Correct Answer / Model Answer" auto-grow
                    v-model="question_info[0].subjective_correct_answer" outlined rows="3"
                    :rules="[(v) => !!v || 'Answer is required']"></v-textarea>
                </v-col>
              </v-row>
            </v-card>
            <span v-if="question_info[0].quiztype == 'MCQ'">
              <span v-for="(opt, index) in my_opt_list" :key="opt.opt_id">
                <v-card class="box">
                  <v-row>
                    <v-col cols="12" sm="2" md="2">
                      Option::{{ index + 1 }}
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                      <!-- <ckeditor
                        v-model="opt.option_value"
                        :config="editorConfig"
                      ></ckeditor> -->
                      <v-textarea auto-grow v-model="opt.option_value" outlined rows="3"></v-textarea>
                    </v-col>
                    <v-col cols="12" md="1" sm="1"></v-col>

                    <v-col cols="12" sm="3" md="3">
                      <v-col cols="12" sm="12" md="12">
                        <!-- {{opt.iscorrect}} -->
                        <input type="radio" id="a" :value="opt.iscorrect" @change="radio(index, opt.iscorrect)"
                          :checked="opt.iscorrect" />
                        Correct Answer
                        <v-file-input accept="image/*" v-model="opt.filename" id="file" prepend-icon="mdi-attachment"
                          label="Choose File" show-size name="doc"
                          @change="validateFile4(opt.filename, index)"></v-file-input>
                        <span v-if="opt.mcq_option_file_path != null">
                          Previous File <br />
                          <a class="p-2" :href="aws_path +
      opt.mcq_option_file_path +
      opt.mcq_filename
      " target="_blank">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-if="opt.mcq_option_file_path !== null" v-bind="attrs" v-on="on">
                                  <v-icon color="black">mdi-eye</v-icon></v-btn>
                              </template>
                              <span> View Option File!!! </span>
                            </v-tooltip>
                          </a>
                          <v-icon color="red" @click="deletedialog_option1(opt.op_id)">mdi-delete-circle</v-icon>
                        </span>
                      </v-col>
                    </v-col>
                    <v-col cols="12" sm="1" md="1">
                      <br />
                      <v-btn color="green" small dark @click="getdeletepair(opt.op_id, opt.iscorrect)">
                        <v-icon title="Delete Option">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </span>
              <v-form id="profile_form" @submit.prevent="submit">
                <v-card class="box" v-for="(input, index) in inputs" in :key="index">
                  <v-col cols="12" sm="12">
                    <v-row>
                      <v-col cols="12" sm="2" md="2">
                        Option {{ sise_opt + index }}<br />
                        <v-btn color="red" fab small dark @click="deleteRow(index)" class="del">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                      <!-- <v-checkbox input type="checkbox" v-model="input.value"></v-checkbox> -->
                      <v-col cols="12" sm="7" md="7">
                        <ckeditor v-model="input.text" :config="editorConfig"></ckeditor>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <v-row>
                          <v-col cols="12">
                            <!-- {{input.value}} -->
                            <input type="radio" id="b" value="b" class="radiospace" v-model="input.value"
                              @change="radio(index, input.value)" :checked="input.value" />
                            <label>Correct Answer</label>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
                              v-model="input.file" accept="image/*" prepend-icon="mdi-attachment" label="Choose File"
                              show-size name="doc" @change="validateFile4(input.file, index)"></v-file-input>
                          </v-col>

                        </v-row>
                      </v-col>

                    </v-row>
                  </v-col>
                </v-card>
              </v-form>
              <div v-show="optionsize <= 2">
                <v-btn class="button" @click="addRow"> Add Option </v-btn>
              </div>
            </span>
            <span v-if="question_info[0].quiztype == 'TrueFalse'">
              <span v-for="(opt, index) in my_opt_list" :key="opt.opt_id">
                <v-card class="box">
                  <v-row>
                    <v-col cols="12" sm="2" md="2">
                      Option::{{ index + 1 }}
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                      <!-- <ckeditor
                        v-model="opt.option_value"
                        :config="editorConfig"
                      ></ckeditor> -->
                      <!-- <v-textarea
                        auto-grow
                        v-model="opt.option_value"
                        outlined
                        rows="3"
                      ></v-textarea> -->
                      <span>{{ opt.option_value }}</span>
                    </v-col>
                    <v-col cols="12" md="1" sm="1"></v-col>

                    <v-col cols="12" sm="3" md="3">
                      <v-col cols="12" sm="12" md="12">
                        <!-- {{opt.iscorrect}} -->
                        <input type="radio" id="a" :value="opt.iscorrect" @change="radio(index, opt.iscorrect)"
                          :checked="opt.iscorrect" />
                        Correct Answer
                      </v-col>
                    </v-col>
                  </v-row>
                </v-card>
              </span>
            </span>
          </v-col>
          <v-row dense justify="center">
            <v-btn class="button" @click="
      saveEditedQuestion(my_opt_list, question_info[0].quiztype)
      ">Update</v-btn>
            <v-btn class="button" @click="dialog_edit = false">Cancel</v-btn>
          </v-row>
        </v-card>
        <!-- </v-card> -->
      </v-dialog>
    </Span>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please Wait
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="dialog_delete_option1" persistent max-width="500px">
      <v-card>
        <v-container>
          <v-card class="box">
            <input type="hidden" v-model="deleteItem_opt1.delete_id1" />
            <strong>Are you sure you want Delete this file???</strong>
            <v-row justify="center">
              <v-btn class="button" text @click="dialog_delete_option1 = false">No</v-btn>
              <v-btn class="button" text @click="deletefile()">Yes</v-btn>
            </v-row>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>

    <v-row justify="center" v-if="show_response_card">
      <v-dialog v-model="show_response_card" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar class="toolbar">
            <v-btn icon dark @click="show_response_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>All Results</v-toolbar-title>
            <v-toolbar-items>
              <v-btn dark text @click="show_response_card = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
              <v-toolbar-title>
                <strong> Response Analysis </strong>
              </v-toolbar-title>
            </v-toolbar>
            <v-data-table :headers="headers2" :items="question_response_list" class="elevation-1">
              <template v-slot:[`item.correct_answer`]="{ item }">
                <span v-html="item.correct_answer"> </span>
              </template>
              <template v-slot:[`item.selected_answer`]="{ item }">
                <span v-html="item.selected_answer"> </span>
              </template>
              <template v-slot:[`item.is_correct`]="{ item }">
                <span v-if="item.is_correct">
                  <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                </span>
                <span v-else>
                  <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                </span>
              </template>
              <!-- <template v-slot:[`item.question_file`]="{ item }">
                            <span v-if="item.question_file!=null">
                                <a class="p-2" :href="basepath+item.question_file" target="blank">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon v-if="item.question_file!=null" v-bind="attrs" v-on="on"> <v-icon color="black">mdi-eye</v-icon></v-btn>
                                        </template>
                                        <span>
                                            View Question File!!!
                                        </span>
                                    </v-tooltip>
                                </a>
                            </span>
                            <span v-else>--</span>
                        </template> -->
            </v-data-table>
          </v-card>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog_view_mcq" persistent max-width="800px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <h6>
                <strong> MCQ Question </strong>
              </h6>
            </v-toolbar-title>
          </v-toolbar>

          <br />
          <!-- {{view_question_list}} -->
          <v-card-text>
            <v-container>
              <v-card class="box">
                <v-row justify="center">
                  <span class="text1">
                    <strong>
                      Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                  </span>
                  <v-col cols="12" sm="12" md="12">
                    <center>
                      <span class="text1">
                        <strong> Problem Statement</strong></span>
                    </center>
                  </v-col>
                </v-row>

                <span v-if="view_question_list.filepath != null">
                  <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                    v-html="view_question_list.quizQuestion_text">
                  </span>
                  <img class="imgs" :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)" />
                </span>
                <span v-else v-html="view_question_list.quizQuestion_text">
                </span>
                <v-col cols="12" sm="12" md="12">
                  <center>
                    <span class="text1"> <strong>Options</strong></span>
                  </center>
                </v-col>
                <span v-for="option in view_question_list.option_list" :key="option.op_id">
                  <v-row>
                    <input class="radiospace" type="radio" v-if="option.iscorrect" :checked="option.op_id" />
                    <input type="radio" name="opt" class="radiospace" v-else v-model="option.op_id" disabled />
                    <span class="span-mr" v-if="option.mcq_option_file_path == null" v-html="option.option_value">
                    </span>
                    <span v-else>
                      <span class="span-mr" v-if="option.option_value" v-html="option.option_value">
                      </span>
                      <img class="imgs" :src="basepath +
      option.mcq_option_file_path +
      option.mcq_filename
      " @click="
      zooimg(
        basepath +
        option.mcq_option_file_path +
        option.mcq_filename
      )
      " />
                    </span>
                  </v-row>
                </span>
              </v-card>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row>
              <v-btn color="error" class="justify-center" rounded @click="dialog_view_mcq = false">Close</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog_view_mwa" persistent max-width="800px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <h6>
                <strong> Fill In The Blanks Question </strong>
              </h6>
            </v-toolbar-title>
          </v-toolbar>
          <br />
          <!-- {{view_question_list}} -->
          <v-card-text>
            <v-container>
              <v-card class="box">
                <v-row justify="center">
                  <span class="text1">
                    <strong>
                      Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                  </span>
                  <v-col cols="12" sm="12" md="12">
                    <center>
                      <span class="text1">
                        <strong> Problem Statement</strong></span>
                    </center>
                  </v-col>
                </v-row>
                <span v-html="view_question_list.quizQuestion_text"> </span>
                <v-col cols="12" sm="12" md="12">
                  <center>
                    <span class="text1"> <strong>Answer(s)</strong></span>
                  </center>
                </v-col>
                <span v-for="option in view_question_list.option_list" :key="option.op_id">
                  <v-row>
                    <input class="radiospace" type="radio" :checked="option.op_id" />
                    <span class="span-mr" v-html="option.correct_answer">
                    </span>
                  </v-row>
                  <!-- </v-card> -->
                </span>
              </v-card>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row>
              <v-btn color="error" class="justify-center" rounded @click="dialog_view_mwa = false">Close</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center" v-if="dialog_view_mtp">
      <v-dialog v-model="dialog_view_mtp" persistent max-width="1050px">
        <v-card>
          <!-- {{view_question_list}}  -->
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <h6>
                <strong> Match The Pair Assignment </strong>
              </h6>
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row justify="center">
              <span class="text1">
                <strong>
                  Marks::{{ view_question_list[0].quizQuestion_marks }}</strong>
              </span>
              <v-col cols="12" sm="12" md="12">
                <center>
                  <span class="text1">
                    <strong>
                      Problem Statement:
                      <span v-html="view_question_list[0].quizQuestion_text">
                      </span></strong></span>
                </center>
              </v-col>
            </v-row>

            <span>
              <v-col class="p-0 m-0" cols="12" sm="12" md="12">
                <v-row>
                  <v-col cols="12" sm="2" md="2"> </v-col>
                  <v-col cols="12" sm="3" md="3">
                    <center><b> Question </b></center>
                  </v-col>
                  <v-col cols="12" sm="5" md="5">
                    <center><b> Answer </b></center>
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                    <center><b> Weightage </b></center>
                  </v-col>
                </v-row>
                <v-row class="p-0 m-0" v-for="(option, index) in view_question_list" :key="index">
                  <span class="p-3">
                    <strong>Pair {{ index + 1 }} </strong>
                  </span>
                  <a class="p-2" :href="basepath + option.filepath" target="blank">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-if="option.filepath != null" v-bind="attrs" v-on="on">
                          <v-icon color="black">mdi-eye</v-icon></v-btn>
                      </template>
                      <span> View Question file!!! </span>
                    </v-tooltip>
                  </a>
                  <v-col class="border1" cols="12" sm="4" md="4">
                    <span v-html="option.question"></span>
                  </v-col>

                  <a class="p-2" :href="basepath + option.mtf_ans_filepath" target="blank">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-if="option.mtf_ans_filepath != null" v-bind="attrs" v-on="on">
                          <v-icon color="black">mdi-eye</v-icon></v-btn>
                      </template>
                      <span> View Answer file!!! </span>
                    </v-tooltip>
                  </a>
                  <v-col class="border1" cols="12" sm="4" md="4">
                    <span v-html="option.option_name"></span>
                  </v-col>
                  <v-col class="border1" cols="12" sm="1" md="1">
                    <center>{{ option.mtf_marks }}</center>
                  </v-col>
                </v-row>
              </v-col>
            </span>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row>
              <v-btn color="error" class="justify-center" rounded @click="dialog_view_mtp = false">Close</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialog_view_swa" persistent max-width="800px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <h6>
                <strong> Single Word Answer Question </strong>
              </h6>
            </v-toolbar-title>
          </v-toolbar>
          <br />
          <!-- {{view_question_list}} -->
          <v-card-text>
            <v-container>
              <v-card class="box">
                <v-row justify="center">
                  <span class="text1">
                    <strong>
                      Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                  </span>
                  <v-col cols="12" sm="12" md="12">
                    <center>
                      <span class="text1">
                        <strong> Problem Statement</strong></span>
                    </center>
                  </v-col>
                </v-row>
                <span v-if="view_question_list.filepath != null">
                  <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                    v-html="view_question_list.quizQuestion_text">
                  </span>
                  <img class="imgs" :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)" />
                </span>
                <span v-else v-html="view_question_list.quizQuestion_text"></span>
                <!-- <span v-html="view_question_list.quizQuestion_text"> -->
                <v-col cols="12" sm="12" md="12">
                  <center>
                    <span class="text1"> <strong>Answer(s)</strong></span>
                  </center>
                </v-col>
                <span v-for="option in view_question_list.option_list" :key="option.op_id">
                  <v-row>
                    <input class="radiospace" type="radio" :checked="option.op_id" />
                    <span class="span-mr" v-html="option.correct_answer">
                    </span>
                  </v-row>
                  <!-- </v-card> -->
                </span>
              </v-card>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row>
              <v-btn color="error" class="justify-center" rounded @click="dialog_view_swa = false">Close</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog_view_subj" persistent max-width="800px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <h6>
                <strong> Subjective Question </strong>
              </h6>
            </v-toolbar-title>
          </v-toolbar>

          <br />
          <!-- {{view_question_list}} -->
          <v-card-text>
            <v-container>
              <v-card class="box">
                <v-row justify="center">
                  <span class="text1">
                    <strong>
                      Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                  </span>
                  <v-col cols="12" sm="12==" md="12">
                    <center>
                      <span class="text1">
                        <strong> Problem Statement</strong></span>
                    </center>
                  </v-col>
                </v-row>
                <span v-if="view_question_list.filepath != null">
                  <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                    v-html="view_question_list.quizQuestion_text">
                  </span>
                  <img class="imgs" :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)" />
                </span>
                <span v-else v-html="view_question_list.quizQuestion_text">
                </span>
                <v-row dense justify="center">
                  <v-col cols="12" sm="7" md="7">
                    <center>
                      <span class="text1">
                        <strong> Correct / Model Answer</strong></span>
                    </center>
                    <span v-html="view_question_list.subjective_correct_answer">
                    </span>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row>
              <v-btn color="error" class="justify-center" rounded @click="dialog_view_subj = false">Close</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <v-row justify="center">
      <v-dialog v-model="dialog_view_tof" persistent max-width="800px">
        <v-card>
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <h6>
                <strong> True Or False Question </strong>
              </h6>
            </v-toolbar-title>
          </v-toolbar>

          <br />
          <!-- {{view_question_list}} -->
          <v-card-text>
            <v-container>
              <v-card class="box">
                <v-row justify="center">
                  <span class="text1">
                    <strong>
                      Marks::{{ view_question_list.quizQuestion_marks }}</strong>
                  </span>
                  <v-col cols="12" sm="12" md="12">
                    <center>
                      <span class="text1">
                        <strong> Problem Statement</strong></span>
                    </center>
                  </v-col>
                </v-row>

                <span v-if="view_question_list.filepath != null || view_question_list.filepath != ''">
                  <span class="span-mr" v-if="view_question_list.quizQuestion_text"
                    v-html="view_question_list.quizQuestion_text">
                  </span>
                  <img class="imgs" :src="basepath + view_question_list.filepath"
                    @click="zooimg(basepath + view_question_list.filepath)" />
                </span>
                <span v-else v-html="view_question_list.quizQuestion_text">
                </span>
                <v-col cols="12" sm="12" md="12">
                  <center>
                    <span class="text1"> <strong>Options</strong></span>
                  </center>
                </v-col>
                <span v-for="option in view_question_list.option_list" :key="option.op_id">
                  <v-row>

                    <input class="radiospace" type="radio" v-if="option.iscorrect" :checked="option.op_id" />
                    <input type="radio" name="opt" class="radiospace" v-else v-model="option.op_id" disabled />
                    <span class="span-mr"
                      v-if="option.mcq_option_file_path == null || option.mcq_option_file_path == ''"
                      v-html="option.option_value">
                    </span>
                    <span v-else>
                      <span class="span-mr" v-if="option.option_value" v-html="option.option_value">
                      </span>
                      <img class="imgs" :src="basepath +
      option.mcq_option_file_path +
      option.mcq_filename
      " @click="
      zooimg(
        basepath +
        option.mcq_option_file_path +
        option.mcq_filename
      )
      " />
                    </span>
                  </v-row>
                </span>
              </v-card>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row>
              <v-btn color="error" class="justify-center" rounded @click="dialog_view_tof = false">Close</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <template v-if="mtp_edit_flag">
      <mtpedit v-model="mtp_edit_flag" :mtp_id="mtp_id" />
    </template>

    <template v-if="singlewordanswer_edit">
      <singlewordedit v-model="singlewordanswer_edit" :singleword_id="singleword_id" />
    </template>

    <template v-if="multiwordanswer_edit">
      <multiwordedit v-model="multiwordanswer_edit" :multiword_id="multiword_id" />
    </template>
    <!-- show editor -->
    <v-row justify="center">
      <v-dialog v-model="show_editor" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar class="toolbar">
            <v-btn icon dark @click="show_editor = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Text Editor</v-toolbar-title>
          </v-toolbar>
          <br />
          <v-row dense justify="center">
            <v-col cols="12" sm="7" md="7">
              <ckeditor v-model="textEditor" :config="editorConfig"></ckeditor>
            </v-col>
            <v-col cols="12" sm="3" md="3" v-if="textEditor">
              <span><v-icon class="icon-quick" title="Copy text"
                  @click="copy(textEditor)">mdi-content-copy</v-icon></span>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-if="imagesizeflaginputs" v-model="dialog_delete" persistent max-width="400px">
      <v-card>
        <v-container>
          <span v-if="imagesizeflaginputs">
            <v-col cols="12" xs="12" sm="12">
              <p class="slide">
                File size should be less than {{ imagesize_new }}KB!
              </p>
            </v-col>
          </span>
          <center>
            <v-btn class="button" text @click="dialog_delete = false">OK</v-btn>
          </center>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete1" persistent max-width="400px">
      <v-card>
        <v-container>
          <v-col cols="12" xs="12" sm="12" md="12">
            <p class="slide">
              File in
              <span v-for="(img, index) in imagetype_new" :key="index">
                {{ img.imagetype }}
              </span>
              Format!!!
            </p>
          </v-col>

          <center>
            <v-btn class="button" @click="dialog_delete1 = false">OK</v-btn>
          </center>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete_pair" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"> Delete Pair </v-card-title>
        <v-card-text> Do you want to Delete this Pair? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog_delete_pair = false">
            No
          </v-btn>
          <v-btn color="green darken-1" text @click="removepair">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { VueMathjax } from "vue-mathjax";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import MTPedit from "@/components/Quiz/Teacher/EditMatchThePair";
import EditSingleWordAnswer from "@/components/Quiz/Teacher/EditSingleWordAnswer";
import EditMultiWordAnswer from "@/components/Quiz/Teacher/EditMultiWordAnswer";
export default {
  components: {
    "vue-mathjax": VueMathjax,
    mtpedit: MTPedit,
    singlewordedit: EditSingleWordAnswer,
    multiwordedit: EditMultiWordAnswer,
  },
  data() {
    return {
      show_response_card: false,
      editorConfig: {
        height: "100px",
        extraPlugins: "mathjax",
        mathJaxLib:
          "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
      },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: null,
      overlay: false,
      crs_list: null,
      crs: null,
      chapter_list: null,
      Level_listAll: null,
      Level_list: null,
      Level: null,
      Level_name: null,
      chapter: null,
      quiz_type_list: null,
      type: null,
      aws_path: null,
      question_list: null,
      dialog_edit: false,
      optionsize: 0,
      inputs: [],
      deleteItem: {
        delete_id: "",
      },
      dialog_delete_que: false,
      qid: null,
      question_info: [],
      imagesizeflaginputs: false,
      imagesizetypeinputs: false,
      imagesize: null,
      imageSizeFlag: false,
      imageTypeFlag: false,
      dialog_zooimg: false,
      dialog_save: false,
      dialog_save_option: false,
      dialog_upload: false,
      imagesize_new: null,
      imagetype_new: null,
      qfile: null,
      my_opt_list: "",
      sise_opt: "",
      dialog_delete_option1: false,
      deleteItem_opt1: {
        delete_id1: "",
        type: "",
      },
      view_question_list: [],
      dialog_view_mcq: false,
      dialog_view_mwa: false,
      dialog_view_mtp: false,
      dialog_view_swa: false,
      dialog_view_subj: false,
      dialog_view_tof: false,
      basepath: null,

      mtp_id: null,
      mtp_edit_flag: false,

      singleword_id: null,
      singlewordanswer_edit: false,

      multiword_id: null,
      multiwordanswer_edit: false,

      show_editor: false,
      textEditor: "",
      dialog_delete: false,
      dialog_delete1: false,
      dialog_delete_pair: false, op_id: null, quiz_question: null
    };
  },
  // editorConfig: {
  //     // The configuration of the editor.
  //     extraPlugins: "mathjax",
  //     mathJaxLib:
  //         // "http://cdn.mathjax.org/mathjax/2.6-latest/MathJax.js?config=TeX-AMS_HTML"
  //         "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
  // },
  updated: function () {
    console.log("Inside updated");
    this.$nextTick().then(() => {
      if (window.MathJax) {
        console.log("rendering mathjax");
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    });
  },
  methods: {
    removepair() {
      let correct = false
      for (let i = 0; i < this.my_opt_list.length; i++) {
        if (this.my_opt_list[i].iscorrect == true) {
          correct = true
        }
      }
      if (correct == false) {
        this.showSnackbar("red", "Please Update Correct Option First..."); // show snackbar
        this.dialog_delete_pair = false;
        return
      }
      this.dialog_delete_pair = false;
      const data = {
        op_id: this.op_id
      };
      this.dialog = true;
      axios
        .post("/LiveClass/deletemcqpair", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Pair Deleted Successfully"); // show snackbar
            this.editItem(this.quiz_question)

          }
        })
        .catch((error) => {
          this.showSnackbar("red", "Something went wrong..."); // show snackbar
        })
        .finally(() => { });
    },
    getdeletepair(op_id, iscorrect) {
      if (iscorrect == true) {
        this.showSnackbar("red", "Cannot Delete....Please Choose Another Correct Option Then Try Again.."); // show snackbar
        return
      }
      this.dialog_delete_pair = true;
      this.op_id = op_id;
    },
    // onInput: function (e) {
    //   this.$emit("update:question_info[0].question", e.target.value);
    // },
    showEditor() {
      this.show_editor = true;
    },
    copy(text) {
      navigator.clipboard.writeText(text);
      //   alert("Text copied to clipboard!!!");
      this.showSnackbar("#4caf50", "Text copied to clipboard!!!");
    },
    async viewQuizQuestion(item) {
      const data = {
        qid: item.id,
        from: "View_Bank",
      };
      try {
        const res = await axios.post("/LiveClass/viewQuestion", data);
        if (res.data.flag == "YES") {
          if (res.data.quiztype == "MCQ") {
            this.dialog_view_mcq = true;
            this.view_question_list = res.data.questions[0];
          }
          if (res.data.quiztype == "MultiWordAnswer") {
            this.dialog_view_mwa = true;
            this.view_question_list = res.data.questions[0];
          }
          if (res.data.quiztype == "SWA") {
            this.dialog_view_swa = true;
            this.view_question_list = res.data.questions[0];
          }
          if (res.data.quiztype == "MTP") {
            this.dialog_view_mtp = true;
            this.view_question_list = res.data.questions[0];
          }
          if (res.data.quiztype == "SUBJECTIVE") {
            this.dialog_view_subj = true;
            this.view_question_list = res.data.questions[0];
          }
          if (res.data.quiztype == "TrueFalse") {
            this.dialog_view_tof = true;
            this.view_question_list = res.data.questions[0];
          }
        }
        if (res.data.flag == "No") {
          this.showSnackbar("red", res.data.snackbar); // show snackbar
        }
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
      }
    },
    deletedialog_question(item) {
      this.dialog_delete_option1 = true;
      this.deleteItem_opt1.delete_id1 = item;
      this.deleteItem_opt1.type = "question";
    },
    deletedialog_option1(item) {
      this.dialog_delete_option1 = true;
      this.deleteItem_opt1.delete_id1 = item;
      this.deleteItem_opt1.type = "option";
    },
    deletefile() {
      //alert(this.deleteItem_opt1.type)
      const data = {
        id: this.deleteItem_opt1.delete_id1,
        type: this.deleteItem_opt1.type,
      };
      axios
        .post("/QuizQuestionBank/deletefile", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "You can not delete this file!!!");
            return;
          } else if (res.data.flag == "YES") {
            this.dialog_delete_option1 = false;
            this.showSnackbar("#4caf50", "File deleted successfully");
            this.editItem(res.data.qid);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong !!!");
            this.dialog_delete_option1 = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
          this.dialog_delete_option1 = false;
        })
        .finally(() => {
          this.dialog_delete_option1 = false;
        });
    },
    saveEditedQuestion(opt, type) {
      let formData;
      if (type == "MCQ") {
        var form = document.getElementById("profile_form");
        formData = new FormData(form);
      } else {
        formData = new FormData();
      }
      if (
        this.qfile == null &&
        this.question_info[0].question == "" &&
        this.que_file == null
      ) {
        this.showSnackbar("#b71c1c", "Please add Question..."); // show snackbar
        return;
      }
      if (type == "MCQ" || type == "TrueFalse") {
        for (let i = 0; i < this.inputs.length; i++) {
          formData.append("opt_id", i);
          formData.append("optiscorrect", this.inputs[i].value);
          formData.append("opttext", this.inputs[i].text);
          formData.append("optfile", this.inputs[i].file);
          if (this.inputs[i].text == "" && this.inputs[i].file == undefined) {
            this.showSnackbar(
              "#b71c1c",
              "Either option text or option image file is compulsory please add..."
            ); // show snackbar
            return;
          }
        }

        let option = {};
        for (let i = 0; i < opt.length; i++) {
          // alert(opt[i].iscorrect)
          option["id" + (i + 1)] = opt[i].op_id;
          formData.append("opt_id" + (i + 1), opt[i].op_id);
          formData.append("opt_value" + (i + 1), opt[i].option_value);
          formData.append("opt_iscorrect" + (i + 1), opt[i].iscorrect);
          formData.append("opt_file" + (i + 1), opt[i].filename);

          if (
            opt[i].option_value == "" &&
            opt[i].filename == null &&
            opt[i].mcq_option_file_path == undefined
          ) {
            //alert("in if")
            this.showSnackbar(
              "#b71c1c",
              "Either option text or option image file is compulsory please add..."
            ); // show snackbar
            return;
          }
        }
      }
      formData.append("question_id", this.question_info[0].qid);
      formData.append("question_text", this.question_info[0].question);
      formData.append("que_file", this.qfile);
      formData.append("diff_level_id", this.Level_name);
      formData.append("weightage", this.question_info[0].weightage);
      formData.append("isapprove", this.question_info[0].isapproved);
      formData.append("subjective_correct_answer", this.question_info[0].subjective_correct_answer);
      this.dialog_upload = true;
      axios
        .post("/QuizQuestionBank/saveEditBank", formData, {})
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Updated Successfully...");
            this.dialog_upload = false;
            this.dialog_edit = false;
            this.inputs = [];
            this.viewBank();
            this.getCourse();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
          this.dialog_upload = false;
          this.dialog_edit = false;
          this.inputs = [];
        })
        .finally(() => {
          this.dialog_upload = false;
          this.dialog_edit = false;
          this.inputs = [];
        });
    },
    addRow() {
      this.inputs.push({
        value: "",
        text: "",
        file: null,
      });
      this.optionsize++;
      this.sise_opt = this.my_opt_list.length + 1;
    },
    deleteRow(index) {
      this.inputs.splice(index, 1);
      this.optionsize--;
    },
    radio(index, id) {
      if (id == "b") {
        //alert("in if")
        for (let i = 0; i < this.my_opt_list.length; i++) {
          this.my_opt_list[i].iscorrect = false;
        }
        for (let i = 0; i < this.inputs.length; i++) {
          if (i == index) {
            if (this.inputs[i].inputs == false) {
              this.inputs[i].value = true;
            }
          } else {
            this.inputs[i].value = false;
          }
        }
      } else {
        //alert("in else")
        for (let i = 0; i < this.my_opt_list.length; i++) {
          if (i == index) {
            if (this.my_opt_list[i].iscorrect == false) {
              //alert("in if")
              this.my_opt_list[i].iscorrect = true;
              for (let i = 0; i < this.inputs.length; i++) {
                this.inputs[i].value = false;
              }
            }
          } else {
            this.my_opt_list[i].iscorrect = false;
          }
        }
      }
    },
    validateFile4(filename, index) {
      let file1 = filename;
      let invalid = "";
      let file_size1 = file1.size;
      let file_name1 = filename.name;
      let ext1 = file_name1.split(".").pop();
      const data = {
        type: "MCQ",
      };
      axios
        .post("/QuizQuestionBank/validatefile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //alert("in firdt if")
            console.log(res.data.imagesize);
            this.imagesize = res.data.imagesize;
            if (file_size1 > this.imagesize) {
              this.imagesizeflaginputs = true;
              this.dialog_delete = true;
              this.my_opt_list[index].filename = "";
            } else {
              this.imagesizeflaginputs = false;
              this.dialog_delete = false;
            }
            console.log(res.data.imagetype);
            this.imagetype = res.data.imagetype;

            for (var i = 0; i < this.imagetype.length; i++) {
              //alert("in for")
              if (ext1 == this.imagetype[i].imagetype) {
                this.imagesizetypeinputs = false;
                this.dialog_delete1 = false;
                return;
              } else {
                this.imagesizetypeinputs = true;
                this.dialog_delete1 = true;

                invalid = "invalidfile";
              }
            }
            if (invalid == "invalidfile") {
              this.my_opt_list[index].filename = null;
            }
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);
        });
    },
    validateFile() {
      let file = this.qfile;
      let file_size = file.size;
      let file_name = this.qfile.name;
      let ext = file_name.split(".").pop();
      const data = {
        type: "MCQ",
      };
      axios
        .post("/QuizQuestionBank/validatefile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.imagesize = res.data.imagesize;
            if (file_size > this.imagesize) {
              //200kb
              this.imageSizeFlag = true;
              this.qfile = null;
            } else {
              this.imageSizeFlag = false;
            }
            this.imagetype = res.data.imagetype;
            //console.log(this.imagetype)
            for (var i = 0; i < this.imagetype.length; i++) {
              //alert(i)
              //alert(this.imagetype[i].imagetype)
              if (ext == this.imagetype[i].imagetype) {
                // alert("in if")
                this.imageTypeFlag = false;
                return;
              }
            }
            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext != this.imagetype[i].imagetype) {
                // alert("in else new for")
                this.imageTypeFlag = true;
                this.qfile = null;
                return;
              }
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        });
    },
    edit(item) {

      this.mtp_edit_flag = false;
      this.singlewordanswer_edit = false;
      if (item.quiztype == "MCQ") {
        this.editItem(item.id);
      }
      if (item.quiztype == "TrueFalse") {
        this.editItem(item.id);
      }
      if (item.quiztype == "SUBJECTIVE") {
        this.editItem(item.id);
      } else if (item.quiztype == "SWA") {
        this.singleword_id = item.id;
        this.singlewordanswer_edit = true;
      } else if (item.quiztype == "MultiWordAnswer") {
        this.multiword_id = item.id;
        this.multiwordanswer_edit = true;
      } else if (item.quiztype == "MTP") {
        this.mtp_id = item.id;
        this.mtp_edit_flag = true;
      }
    },
    editItem(item) {

      const data = {
        qid: item,
      };
      axios
        .post("/QuizQuestionBank/editquestion", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "You can not edit this question!!!");
            return;
          } else if (res.data.flag == "YES") {
            this.question_info = res.data.question_info;
            this.Level_name = res.data.question_info[0].Level_id;
            console.log(this.question_info[0].option_list);
            if (this.question_info[0].quiztype == "MCQ" || this.question_info[0].quiztype == "TrueFalse") {
              this.quiz_question = res.data.qid

              this.my_opt_list = this.question_info[0].option_list;
              for (let i = 0; i < this.my_opt_list.length; i++) {
                this.my_opt_list[i].filename;
                this.my_opt_list[i].radio = "radio" + (i + 1);
              }
            }
            this.imagesize_new = res.data.imagesize / 1000;
            this.imagetype_new = res.data.imagetype;
            this.dialog_edit = true;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong !!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => { });
    },
    deleteitem(item) {
      this.dialog_delete_que = true;
      this.deleteItem.delete_id = item;
    },
    deletequestion() {
      const data = {
        qid: this.deleteItem.delete_id,
      };
      axios
        .post("/QuizQuestionBank/deletequestion", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "You can not delete this question!!!");
            return;
          } else if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Question deleted successfully");
            this.dialog_delete_que = false;
            this.viewBank();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong !!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => { });
    },
    putnull() {
      this.question_list = null;
    },
    viewBank() {
      const data = {
        crs_id: this.crs,
        type: this.type,
        ch_id: this.chapter,
        diffi_level_id: this.Level,
      };
      axios
        .post("/QuizQuestionBank/viewBank", data)
        .then((res) => {
          this.aws_path = res.data.aws_path;
          this.question_list = res.data.question_list;
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getCourse() {
      axios
        .post("/QuizQuestionBank/getCourse")
        .then((res) => {
          this.crs_list = res.data.crs_list;
          this.getdifficultylevel();
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getdifficultylevel() {
      const data = {

      };
      axios
        .post("/QuizQuestionBank/getdifficultylevel", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "Please add Difficulty Level First..!!!");
            return
          }
          else {
            this.Level_list = res.data.difficulty_level_list;
            this.Level_listAll = res.data.difficulty_level_list_All;
          }
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getchapter() {
      const data = {
        crs_id: this.crs,
        type: "view",
      };
      axios
        .post("/QuizQuestionBank/getchapter", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "Please add chapter for selected course !!!"
            );
            return;
          } else if (res.data.flag == "NOQT") {
            this.showSnackbar("#b71c1c", "Please add quiz type!!!");
            return;
          } else {
            this.chapter_list = res.data.chapter_list;
            this.quiz_type_list = res.data.quiz_type_list;
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    this.getCourse();
    this.basepath = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}

tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
}

tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}

td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
}

@media (min-width: 320px) {

  td,
  th {
    display: table-cell !important;
  }

  td+td,
  th+th {
    width: auto;
  }
}

v-simple-table {
  white-space: nowrap !important;
  text-align: center;
}

.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}

.radiospace {
  margin: 0.5rem !important;
  padding: 0%;
}

.button {
  border: 2px solid #424093 !important;
  color: #424093;
  background: transparent !important;
  border-radius: 50px;
  margin: 0.5rem !important;
}

.button:hover {
  color: white;
  background: #424093 !important;
}

.toolbar {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}

.btn-submit:hover {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}

.radiospace {
  margin: 1rem !important;
}

.span-mr {
  margin: 0.7rem !important;
}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  width: auto;
}

.msg {
  color: red;
}

.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}

.name {
  color: #ffb500;
  font-weight: bold;
  letter-spacing: 1px;
}

v-chip {
  width: auto;
}

.text1 {
  color: darkblue !important;
  margin-left: 40px;
}

.textq {
  color: rgb(24, 155, 68) !important;
  margin-left: 40px;
}

.textd {
  color: rgb(168, 173, 196) !important;
  margin-left: 40px;
}

.textg {
  color: #ffb500 !important;
  margin-left: 40px;
}

.box {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
  border: 2px solid rgb(195, 214, 218) !important;
  border-radius: 10px;
}

.card-border1 {
  margin: 8px !important;
  padding: 8px;
  border: 2px solid white !important;
  border-radius: 10px;
}

.marks {
  text-align: center;
}

.card-border {
  border: 2px solid #424093;
  border-radius: 1px;
  padding: 5px;
  margin: 1rem !important;
  width: auto;
}

.border {
  border: 2px solid gray;
  padding: 10px;
  margin: 10px;
}

.border1 {
  border: 1px solid black;
  padding: 5px;
  margin: 10px;
}

.text-color {
  color: darkblue;
}
</style>

</style>
